import { render, staticRenderFns } from "./youtubeVideo.component.vue?vue&type=template&id=2c109e68&scoped=true&"
import script from "./youtubeVideo.component.vue?vue&type=script&lang=js&"
export * from "./youtubeVideo.component.vue?vue&type=script&lang=js&"
import style0 from "./youtubeVideo.component.vue?vue&type=style&index=0&id=2c109e68&scoped=true&lang=scss&"
import style1 from "./youtubeVideo.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c109e68",
  null
  
)

export default component.exports